import {mainQuery} from '@github-ui/react-core/future/main-query'
import {ReposListLoadingSkeleton} from '@github-ui/repos-list'

import {reposFinderAppBuilder} from '../config/app-builder'
import type {PagePayload} from '../types'

export const reposFinderPageRoute = reposFinderAppBuilder.createQueryRouteConfig('reposFinderPageRoute', {
  path: '/repos',
  queries: [
    mainQuery<PagePayload>({
      queryDeps: ({pathname, searchParams}) => ({
        pathname,
        searchParams: {q: searchParams.get('q') || '', page: searchParams.get('page') || '1'},
      }),
      uiServiceOptions: {mode: 'streaming'},
    }),
  ],
  uiServiceOptions: {
    tsrConfig: {
      validateSearch: (search: Record<string, unknown>): {q?: string; page?: string} =>
        search as {q?: string; page?: string},
      pendingComponent: ReposListLoadingSkeleton,
      pendingMinMs: 0,
    },
  },
})
